import log from 'utils/logger';

const logger = log('TransactionLoggingMiddleware');

const transactionLogging = () => next => action => {
    const result = next(action);

    logger.debug(action);
    return result;

};

export default transactionLogging;


// WEBPACK FOOTER //
// ./src/store/transactionLogging.js